import React from 'react'

const ReportsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_16550_50663"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_16550_50663)">
        <path
          d="M2.70078 17.3C2.51745 17.1167 2.42578 16.8873 2.42578 16.612C2.42578 16.3373 2.51745 16.1 2.70078 15.9L8.70078 9.85C8.80078 9.76667 8.90911 9.7 9.02578 9.65C9.14245 9.6 9.26745 9.575 9.40078 9.575C9.53411 9.575 9.66345 9.6 9.78878 9.65C9.91345 9.7 10.0174 9.76667 10.1008 9.85L13.4008 13.15L18.6008 8H17.0008C16.7174 8 16.4801 7.90433 16.2888 7.713C16.0968 7.521 16.0008 7.28333 16.0008 7C16.0008 6.71667 16.0968 6.479 16.2888 6.287C16.4801 6.09567 16.7174 6 17.0008 6H21.0008C21.2841 6 21.5214 6.09567 21.7128 6.287C21.9048 6.479 22.0008 6.71667 22.0008 7V11C22.0008 11.2833 21.9048 11.5207 21.7128 11.712C21.5214 11.904 21.2841 12 21.0008 12C20.7174 12 20.4801 11.904 20.2888 11.712C20.0968 11.5207 20.0008 11.2833 20.0008 11V9.4L14.1008 15.3C14.0008 15.4 13.8924 15.4707 13.7758 15.512C13.6591 15.554 13.5341 15.575 13.4008 15.575C13.2674 15.575 13.1424 15.554 13.0258 15.512C12.9091 15.4707 12.8008 15.4 12.7008 15.3L9.40078 12L4.07578 17.325C3.89245 17.5083 3.66745 17.6 3.40078 17.6C3.13411 17.6 2.90078 17.5 2.70078 17.3Z"
          fill="#F8FAFC"
        />
      </g>
    </svg>
  )
}

export default ReportsIcon
